<template>
  <Popup
    position="bottom"
    v-model:show="show"
    height="calc(100% - 40px)"
  >
    <div class="h5-description-dialog">
      <div class="h5-description-dialog__header">
        Products Specifications
        <img
          @click="show = false"
          src="@/assets/images/close-icon.svg"
          alt=""
        >
      </div>
      <div class="h5-description-dialog__content">
        <div
          v-for="(item, index) in descAllList"
          key="index"
          class="h5-description-dialog-item"
        >
          <div class="h5-description-dialog-item__attributeNameTrans">
            {{ item?.attributeNameTrans }}
          </div>
          <div class="h5-description-dialog-item__valueTrans">
            {{ item?.valueTrans }}
          </div>
        </div>
      </div>
    </div>
  </Popup>
</template>

<script setup>
import { Popup } from '@/components/Popup'

defineProps({
  descAllList: {
    type: Object,
    required: true
  }
})

const show = defineModel('show', { type: Boolean })
</script>

<style lang="less">
@import './index.less';
</style>
